import { useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import ReactPaginate from "react-paginate";
import TopBack from "./components/subcompdash/Topback";
// import { firestore } from '../firebase';

function ReturingToday() {
    const [datas] = useState(null);

    const formatDate = (value) => {
        if (value) {
            return moment(String(value)).format("hh:mm A");
        }

        return "";
    };
    const formatDate2 = (value) => {
        if (value) {
            return moment(String(value)).format("MM/DD/YYYY");
        }

        return "";
    };

    const today = new Date();
    const week = new Date();
    week.setDate(today.getDate());
    // console.log(week.getDate());
    // const date1 = new Date(week.setHours(0, 0, 0, 0));
    // const date2 = new Date(week.setHours(23, 59, 59, 59));
    // firestore
    //     .collection('Reservations')
    //     .orderBy('dropOffDate')
    //     .where('dropOffDate', '>=', date1)
    //     .where('dropOffDate', '<=', date2)
    //     .onSnapshot((snapshot) => {
    //         const postData = [];
    //         snapshot.forEach((doc) => {
    //             //   if (
    //             //     doc.data().isApproved &&
    //             //     doc.data().isCarSelected &&
    //             //     !doc.data().isCarPickedUp
    //             //   )
    //             postData.push({ ...doc.data(), id: doc.id });
    //         });
    //         setDatas(postData);
    //     });

    // return setDatas(null);

    const [pageNumber, setPageNumber] = useState(0);
    const usersPerPage = 17;
    const pagesVisited = pageNumber * usersPerPage;
    const displayUsers = datas?.slice(pagesVisited, pagesVisited + usersPerPage).map((user) => (
        <tbody key={user.serialID}>
            <tr className="fontSemi bodytt">
                <td style={{ width: "14rem" }}>
                    {user.serialID < 1000 && user.serialID > 99
                        ? `0${user.serialID}`
                        : user.serialID < 100 && user.serialID > 9
                          ? `00${user.serialID}`
                          : `000${user.serialID}`}
                    {/* {user.id} */}
                </td>
                <td style={{ width: "25rem" }}>{user.customerName}</td>
                <td style={{ width: "25rem" }}>{formatDate2(new Date(user.dropOffDate.seconds * 1000))}</td>
                <td style={{ width: "25rem" }}>{formatDate(new Date(user.dropOffDate.seconds * 1000))}</td>
                <td style={{ width: "25rem" }}>{user.carType}</td>

                {/* <td>{user?.pickupDate}</td>
                    <td>{user?.dropoffDate}</td> */}
                {/* <td>{user.license && user.license.number}</td> */}
                <td style={{ width: "8rem" }}>
                    <Link style={{ textDecoration: "none" }} to={`/reservations/${user?.id}`}>
                        <div className="viewbb fontbold">View</div>
                    </Link>
                </td>
            </tr>
        </tbody>
    ));

    const pageCount = datas && Math.ceil(datas.length / usersPerPage);
    const changePage = ({ selected }) => {
        setPageNumber(selected);
    };
    return (
        <>
            <TopBack />
            <div className="min-h-0 flex-1">
                <div
                    style={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                    }}>
                    <div className="text-[1.2rem] fontbold">
                        Returing today<span className="text-[#5d5dff]">({datas?.length})</span>
                    </div>
                    <div style={{ height: "42rem" }}>
                        <table className="ttcont">
                            <tbody>
                                <tr className="fontRegular headtt">
                                    <th style={{ width: "10rem" }}>Res ID</th>
                                    <th style={{ width: "15rem" }}>Customer name</th>
                                    <th style={{ width: "18rem" }}>Dropoff date</th>
                                    <th>Dropoff time</th>
                                    <th>Car type</th>

                                    <th style={{ width: "8rem" }} />
                                </tr>
                            </tbody>
                            {displayUsers}
                        </table>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            color: "#acacb9",
                            justifyContent: "space-between",
                            width: "75rem",
                            flex: "1",
                            alignItems: "end",
                        }}>
                        <div className="info fontLight" style={{ margin: "12px 0" }}>
                            Page {pageNumber + 1} of {pageCount} pages | {pagesVisited + 1}-
                            {datas && Math.min(datas.length, pagesVisited + usersPerPage)} items of total{" "}
                            {datas?.length} items
                        </div>
                        <ReactPaginate
                            previousLabel={""}
                            nextLabel={""}
                            pageCount={pageCount}
                            onPageChange={changePage}
                            containerClassName={"pagination fontRegular"}
                            activeClassName={"paginateactive"}
                            previousLinkClassName={"previousP"}
                            nextLinkClassName={"nextP"}
                            breakLabel={"..."}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default ReturingToday;
